<template>
  <div class="analytics-top-box" v-if="data">
    <div class="box-header">
      <SvgIcon name="top-rank-flag-2" />
      <span>{{ data.title }}</span>
    </div>
    <div :class="['box-body', data.user && 'box-body--hover']" @click.stop="goProfile(data.user)">
      <figure class="avatar">
        <img v-if="data.user && data.user.userProfile && data.user.userProfile.avatar_full_url"
          class="had-img"
          :src="data.user.userProfile.avatar_full_url"
          @error="imageError($event)"
        />
        <img v-else src="@/assets/images/user.png" />
      </figure>
      <div class="value-box">
        <div class="value">
          <SvgIcon :name="data.icon" />
          {{ show_text }}
        </div>
        <div class="name">
          {{ data.user ? data.user.first_name + ' ' + data.user.last_name : '--' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/ui/SvgIcon.vue';

export default {
  name: 'AnalyticsTopBox',

  components: { SvgIcon },

  props: {
    data: { type: Object },
  },

  data() {
    return { show_text: '--' };
  },

  mounted() {
    if (this.data.user && this.data.user.total_count !== 0) {
      this.show_text = this.data.icon === 'shopping-cart'
        ? '$' + Number(this.data.user.total_count).toFixed(2)
        : Number(this.data.user.total_count).toLocaleString();
    }
  },

  methods: {
    imageError(event) {
      event.target.src = require('@/assets/images/user.png');
    },

    goProfile(data) {
      if (data) {
        data.id = data.anchor_creator_id;
        data.user_id = data.anchor_creator_id;
        if (this.$store.state.creator_data_open) {
          this.EventBus.emit('update-modal-creator', data);
        } else {
          setTimeout(() => { this.EventBus.emit('open-creator-modal', data); }, 10);
        }
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss">
.analytics-top-box {
  width: calc(25% - 16px);
  margin: 0 8px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  .box-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    font: var(--font-fg-12);
    color: var(--black-90);

    svg {
      width: 14px;
      height: 14px;
      fill: #F5A623;
    }
  }

  .box-body {
    display: flex;
    align-items: center;
    padding: 12px 10px;

    &--hover {
      cursor: pointer;
      &:hover { background-color: var(--bg-08); }
    }

    .avatar {
      height: 32px;
      padding-right: 10px;
      flex-shrink: 0;

      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid var(--black-40);
      }
    }

    .value-box {
      .value {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: var(--dark-blue);

        svg {
          width: 16px;
          height: 16px;
          fill: var(--pink);
          margin-right: 5px;
        }
      }

      .name {
        font-size: 10px;
        color: var(--black-90);
        margin-top: 2px;
      }
    }
  }
}

.report-box {
  margin: 0 -8px 16px -8px;
  display: flex;

  .analytics-top-box {
    width: calc(25% - 16px);
    margin: 0 8px;
  }

  &.is-link-user-box {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin: 0;

    .analytics-top-box {
      width: 100%;
      margin: 0;
    }
  }
}
</style>
